export default __webpack_public_path__ + "static/media/inbar-twizzer.24df2e51.png";